import React, { FC, ReactNode } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { theme } from "src/config";
import { Button, Spacer } from ".";
import { Heading } from "./heading";
import Box from "react-raster";

interface ConfirmationModalProps {
  onConfirm?: () => void;
  onCancel?: () => void;
  onDelete?: () => void;
  message?: string;
  content?: ReactNode;
  label?: string;
  disabled?: boolean;
  confirmButtonLabel?: string,
  cancelButtonLabel?: string,
}

const ConfirmationButtons = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Content = styled.div`
  font-size: ${theme.font.size.small};
  margin-bottom: 1rem;
  text-align: left;
  max-width: 35rem;
`;

export const ConfirmationDialog: FC<ConfirmationModalProps> = (props) => {
  const { t, i18n } = useTranslation();

  const { confirmButtonLabel, cancelButtonLabel, message, label, onConfirm, onCancel, content, disabled } = props;

  return (
  <>
      <Box padding="1rem 1rem">
        <Heading type="h3">
          {label}
        </Heading>
        <Box padding="1rem 0 0.5rem 0">
          {message && 
            <Content>{message}</Content>
          }
          { content && 
          <div>
            {content}
          </div>
          }
        </Box>
        <ConfirmationButtons>
          <Button
            disabled = {disabled}
            variant  = "alert"
            size     = "small"
            onClick  = {(e) => {
              onConfirm();
              e.stopPropagation();
            }}
          >
            {confirmButtonLabel || t("delete")}
          </Button>
          <Spacer />
          <Button
            variant = "outlined"
            size    = "small"
            onClick = {(e) => {
              onCancel();
              e.stopPropagation();
            }}
          >
            {cancelButtonLabel || t("cancel")}
          </Button>
        </ConfirmationButtons>
      </Box>
    </>
  );
};
